"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellationTracker = void 0;
/**
 * Wraps send wrapper and manages adding and removing AbortController
 * to enbale a cancellation API.
 */
const cancellationTracker = (send, cancellationMap) => async (request) => {
    const { cancellationToken } = request;
    if (cancellationToken) {
        cancellationMap.set(cancellationToken, new AbortController());
    }
    try {
        return await send(request);
    }
    finally {
        cancellationToken && cancellationMap.delete(cancellationToken);
    }
};
exports.cancellationTracker = cancellationTracker;
